const AwardsEndPoints = {
  FindMyAward: '/api/findmyaward/search',
}

const HeartbeatEndpoints = {
  Heartbeat: '/api/Health/heartbeat',
}
const AbrEndpoints = {
  GetAbnDetails: '/api/abnsearch/getabndetails',
  GetAbnMatchingNames: '/api/abnsearch/getabnmatchingnames',
}

const AddressEndpoints = {
  GetLocations: '/api/address',
}

const ChoicesEndpoints = {
  GetEntry: '/api/gethelp',
  GetNextSelectionByChoice: '/api/gethelp/{id}/next',
  GetPreviousSelectionByChoice: '/api/gethelp/{id}/previous',
}

const UnpaidWagesEndpoints = {
  Submit: '/api/UnclaimedMoney/submit',
  PossibleMatch: '/api/UnclaimedMoney/checkPossibleMatch',
}

const InteractiveTemplateEndpoints = {
  GetForm: '/api/interactivetemplate/GetForm',
  PostForm: '/api/interactivetemplate/PostForm',
}

const WorkplaceQuizEndpoints = {
  GetWorkplaceQuiz: '/api/workplacequiz',
  GetQuizById: '/api/workplacequiz/{id}',
  CheckAnswer: '/api/workplacequiz/SubmitQuiz',
}
const CalloutEndpoints = {
  GetCalloutByPage: '/api/callout/GetCalloutsByPage/{page}?position={position}',
}
const GovCMSEndpoints = {
  GetFooterContents: '/api/fairwork/GetFooterContentLinks',
  GetHeaderContents: '/api/fairwork/GetHeaderContentLinks',
}
const RefDataEndpoints = {
  GetFeedbackLookupData: '/api/feedback',
}
const FeedbackEndpoints = {
  CreateFeedback: '/api/feedback/CreateFeedback',
}

const AnonymousResources = {
  AbrEndpoints,
  HeartbeatEndpoints,
  AddressEndpoints,
  AwardsEndPoints,
  ChoicesEndpoints,
  UnpaidWagesEndpoints,
  InteractiveTemplateEndpoints,
  WorkplaceQuizEndpoints,
  CalloutEndpoints,
  GovCMSEndpoints,
  RefDataEndpoints,
  FeedbackEndpoints,
}

export default AnonymousResources
